export default __webpack_public_path__ + "static/media/image4.853416b5.png";